<script setup lang="ts">
import { useRouter } from "vue-router";
import { computed, getCurrentInstance } from "vue";

import TcIconButton from "@/Components/Extend/TcIconButton.vue";
import VideoCallNotification from "@/Modules/VideoCall/Components/VideoCallNotification.vue";

import useVideoCallStore from "@/Modules/VideoCall/Store";

import { hasValue } from "@/Utils/Objects";

export interface HeaderProps {
  hideForDesktop?: boolean;
  onBack?: () => void;
}

const router = useRouter();
const videoCallStore = useVideoCallStore();

const props = withDefaults(defineProps<HeaderProps>(), { hideForDesktop: false });

const hasBackButton = computed(() => hasValue(getCurrentInstance()?.vnode.props?.onBack));

const goBack = () => {
  if (props.onBack === undefined) {
    router.back();
  } else {
    props.onBack();
  }
};
</script>

<template>
  <div class="header__wrapper">
    <header class="header" :class="{ 'hide-for-desktop': hideForDesktop, 'header--no_back': !hasBackButton }">
      <TcIconButton v-if="hasBackButton" class="header__back" size="md" iconName="Back" @click="goBack" />

      <span class="header__title">
        <slot />
      </span>
    </header>

    <VideoCallNotification v-if="videoCallStore.isHiddenVideoCall" class="video_notification show-mobile" />
  </div>
</template>

<style scoped lang="scss">
.header {
  @include sp.padding(x, 4);

  display: flex;
  gap: $space-4;
  align-items: center;
  min-height: $size-bar-height-xs;

  &.hide-for-desktop {
    position: absolute;
    top: 0px;
    width: 100%;
    left: 0;
  }

  &__back {
    display: flex;
    padding: 0;
  }

  &__title {
    @include text.general(high, m);
    @include colors.color(content, high);

    flex-grow: 2;
  }
}

.header__wrapper {
  @include sp.padding(false, 0, true);

  flex-direction: column;
  display: flex;

  .header {
    width: 100%;
  }

  .video_notification {
    display: flex;
    width: 100%;
  }
}

@media (min-width: $breakpoint-m) {
  .header {
    min-height: $size-bar-height-md;
    &.hide-for-desktop {
      display: none;
    }
  }
}
</style>
